export default __webpack_public_path__ + "static/media/box.abd24af0.svg";